export default __webpack_public_path__ + "static/media/a038-5.0a58072e.svg";